const gradeList = [
  { name: "B1[学部1年]", id: 1 },
  { name: "B2[学部2年]", id: 2 },
  { name: "B3[学部3年]", id: 3 },
  { name: "B4[学部4年]", id: 4 },
  { name: "M1[修士1年]", id: 5 },
  { name: "M2[修士2年]", id: 6 },
  { name: "D1[博士1年]", id: 7 },
  { name: "D2[博士2年]", id: 8 },
  { name: "D3[博士3年]", id: 9 },
  { name: "GD1[イノベ1年]", id: 10 },
  { name: "GD2[イノベ2年]", id: 11 },
  { name: "GD3[イノベ3年]", id: 12 },
  { name: "GD4[イノベ4年]", id: 13 },
  { name: "GD5[イノベ5年]", id: 14 },
  { name: "その他", id: 15 },
]

export default gradeList